module.exports = __webpack_public_path__ + "static/media/my.0fb65fd8.png";